var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-header',{staticClass:"legal-page-header"},[_c('div',{staticClass:"tag-title"},[(_vm.title)?_c('h1',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }